import { jsx as _jsx } from "react/jsx-runtime";
import Select from 'react-select';
import { dropdownColorTheme, dropdownStyle } from '../../Input/components/Dropdown';
export const SizePerPageButton = ({ options: originalOptions, currSizePerPage, onSizePerPageChange }) => {
    const options = originalOptions.map((o) => ({
        value: o.page,
        label: o.text
    }));
    return (_jsx(Select, { isMulti: false, styles: dropdownStyle, theme: dropdownColorTheme, value: { value: currSizePerPage, label: currSizePerPage }, options: options, className: 'pagination-page-select', classNamePrefix: 'pagination-page-select', onChange: (opt) => {
            if (opt && typeof opt === 'object' && 'value' in opt) {
                onSizePerPageChange(+opt.value);
            }
        } }));
};
